<app-dynamic-form
  [formProperties]="formProperties"
  [formGroup]="formGroup"
></app-dynamic-form>
